export default ['#3D9BD4', '#41C0E6', '#6BDEDF', '#9DE3B2', '#FCD458', '#FA9375', '#F46589', '#D557A5', '#DD85CA', '#E1B5F0', '#938FF2', '#7972E6', '#8FBAFE']
